"use client";

import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

import { AuthAudienceToggle } from "@/app/(discover)/components/auth/auth-audience-toggle";
import {
  JOB_SEEKER_HEADINGS,
  SIGNIN_CONFIG,
} from "@/app/(discover)/components/auth/auth-page-config";
import { AuthPageLayout } from "@/app/(discover)/components/auth/auth-page-layout";
import { HiringPanel } from "@/app/(discover)/components/auth/hiring-panel";
import AuthPageLoader from "@/app/(discover)/components/auth-page-loader";
import { getHireReturnTo } from "@/app/(hire)/lib/return-to";
import { AuthFormWrapper } from "@/components/auth/auth-form-wrapper";
import { formMode } from "@/components/auth/form-mode";
import { useAuthRedirect } from "@/hooks/use-auth-redirect";
import { AUTH_AUDIENCES } from "@/lib/constants/auth-audiences";
import routes from "@/lib/routes";

function LoginPageContent() {
  const searchParams = useSearchParams();
  const query = searchParams.toString();
  const fallback = routes.getJobs();
  const redirectTo = getHireReturnTo(searchParams, fallback);
  const shouldShowLoading = useAuthRedirect(redirectTo, {
    fullPageLoad: redirectTo !== fallback,
  });

  if (shouldShowLoading) {
    return <AuthPageLoader />;
  }

  const headings = JOB_SEEKER_HEADINGS[formMode.signin];

  return (
    <AuthPageLayout
      title={headings.title}
      subtitle={headings.subtitle}
      heroTitle={SIGNIN_CONFIG.heroTitle}
      heroDescription={SIGNIN_CONFIG.heroDescription}
      features={SIGNIN_CONFIG.features}
      headerSlot={
        <AuthAudienceToggle active={AUTH_AUDIENCES.JOB_SEEKER} query={query} />
      }
      belowCardSlot={<HiringPanel mode={formMode.signin} query={query} />}
    >
      <Suspense fallback={null}>
        <AuthFormWrapper formMode={formMode.signin} />
      </Suspense>
    </AuthPageLayout>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={<AuthPageLoader />}>
      <LoginPageContent />
    </Suspense>
  );
}
